export default {
  BACKLOG: 'BACKLOG',
  DECOUPAGE: 'DECOUPAGE',
  POLISSAGE: 'POLISSAGE',
  FINI: 'FINI',
}
